import { useAppQuery } from '@/helpers/api/query'

import { createInstance } from '@/helpers/api/base'
import { RouteBusStops } from '@/types/logs'

const GET_ROUTE_BUS_STOPS = 'GET_BUS_STOPS'

export const useGetRouteBusStops = (retrieveAnyway: boolean, routes?: string[]) =>
    useAppQuery<RouteBusStops[]>({
        queryKey: [GET_ROUTE_BUS_STOPS, routes],
        queryFn: ({ queryKey }) =>
            createInstance({
                url: '/routes/bus-stops',
                method: 'GET',
                params: {
                    Routes: queryKey[1],
                },
                paramsSerializer: {
                    indexes: null,
                },
            }),
        staleTime: Infinity,
        enabled: !!routes && (routes.length > 0 || retrieveAnyway),
    })
